import './conversation.css';

import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import useAuth from '../../hooks/useAuth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import Message from './Messages/Message';

function Conversation() {
    const {auth} = useAuth();
    const axiosPrivate = useAxiosPrivate();
    const [message, setMessage] = useState('');
    const [chats, setChats] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [sent, setSent] = useState(false);

    const to = useParams().to;

    useEffect(() => {
        {
            //Get Request
            fetchMessages();
        }
    }, [sent, to]);

    async function sendMessage(e) {
        e.preventDefault();
        try {
            if(message){
                const response = await axiosPrivate.post('/conversation/send', {
                    message: message,
                    to: to,
                });
                console.log(response);
                setSent(!sent);
                setMessage('');
                setChats(response.data?.chats);
            }
            // fetchMessages();
        } catch (error) {
            console.log(error);
        }
    }
    const fetchMessages = async () => {
        try {
            const response = await axiosPrivate.get('/conversation/fetchMessages/' + to);
            // if (response.ok) {
            console.log('fetchChat',response.data?.chats);
            setChats(response.data?.chats);
            setLoaded(true);
        // } else {
        //     console.log('error');
        // }
        }
        catch (error) {
            console.log(error);
        }
    };
    return (
        // ! pb of number of messages is due to directly the height in id='chat' and also 'chat content'
        <div
            className="container-fluid bg-light"
            id="chat"
        >
            <div
                className="content d-flex flex-column"
                id="chat-content"
            >
                {/* {chats.map((m) => {
                    console.log('chatLength' ,chats.length);
                    return (
                        <p key={m?._id}>{m.message}</p>
                    );
                })} */}
                {/* {JSON.stringify(chats)} */}
                {loaded
                    ? chats.map((m) => {
                        console.log('chatLength' ,chats.length);
                        return (
                            <Message
                                key={m._id}
                                user={m.user == auth?.userId ? true : false}
                                message={m.message}
                                time={m.time}
                            />
                        );
                    })
                    : ''}
            </div>
            <form className="tools form-row">
                <input
                    onChange={(e) => {
                        setMessage(e.target.value);
                    }}
                    value={message}
                    id="newMessage"
                    className="form-control col mr-2"
                    type="text"
                    name=""
                    placeholder="Message"
                />
                <Button
                    onClick={sendMessage}
                    // className="btn btn-primary "
                    variant='contained'
                    type="submit"
                >
                        send
                </Button>
            </form>
        </div>);
}

export default Conversation;
